import styled, { css } from 'styled-components';

// @ts-nocheck
var MultiSelect = styled.div.withConfig({
  displayName: "style__MultiSelect",
  componentId: "sc-18jps5r-0"
})(["background-color:var(--color-white);box-sizing:border-box;cursor:pointer;display:inline-block;height:56px;line-height:1;min-width:100px;position:relative;", " ", ""], function (props) {
  return props.disabled && css(["fill:var(--color-grey-300);cursor:default;"]);
}, function (props) {
  return props.hasNoLabel && css(["height:40px;"]);
});
var Content = styled.div.withConfig({
  displayName: "style__Content",
  componentId: "sc-18jps5r-1"
})(["border:1px solid var(--color-grey-400);height:100%;padding:12px 12px 8px;transition:border-color var(--transition);", " ", ""], function (props) {
  return props.disabled && css(["border-color:var(--color-grey-300);"]);
}, function (props) {
  return props.invalid && css(["border-color:var(--color-element-input-error);"]);
});
var Label = styled.span.withConfig({
  displayName: "style__Label",
  componentId: "sc-18jps5r-2"
})(["color:var(--color-grey-600);display:inline-block;font-size:12px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap;width:100%;", " ", ""], function (props) {
  return props.disabled && css(["color:var(--color-grey-400);"]);
}, function (props) {
  return props.invalid && css(["border-color:var(--color-element-input-error);"]);
});
var Options = styled.div.withConfig({
  displayName: "style__Options",
  componentId: "sc-18jps5r-3"
})(["background-color:var(--color-white);box-shadow:0 0 4px var(--color-black);box-sizing:border-box;font-size:16px;min-width:100%;padding:0 8px 8px;position:absolute;z-index:1;padding:10px;", " .sg-multi-select__option-check-box{margin-top:8px;}"], function (props) {
  return props.disabled && css(["color:var(--color-grey-300);cursor:default;display:none;"]);
});
var SelectedValuesContainer = styled.div.withConfig({
  displayName: "style__SelectedValuesContainer",
  componentId: "sc-18jps5r-4"
})(["display:flex;fill:var(--color-grey-600);justify-content:space-between;padding-right:20px;", " .sg-multi-select__arrow-icon{display:inline-block;font-size:13px;margin-top:3px;margin-right:10px;pointer-events:none;position:absolute;right:4px;height:14px;width:14px;}"], function (props) {
  return props.disabled && css(["color:var(--color-grey-300);fill:var(--color-grey-300);"]);
});
var SelectedValues = styled.span.withConfig({
  displayName: "style__SelectedValues",
  componentId: "sc-18jps5r-5"
})(["overflow:hidden;padding-bottom:2px;text-overflow:ellipsis;white-space:nowrap;width:100%;"]);
var Overlay = styled.div.withConfig({
  displayName: "style__Overlay",
  componentId: "sc-18jps5r-6"
})(["bottom:0;left:0;opacity:0;position:fixed;right:0;top:0;z-index:1;"]);

export { Content, Label, MultiSelect, Options, Overlay, SelectedValues, SelectedValuesContainer };
//# sourceMappingURL=style.js.map
